import React from 'react';

const NoticeListSkeleton: React.FC = () => {
    return (
        <main className="bg-gray-50 min-h-screen overflow-y-auto">
            <div className="container mx-auto px-4 sm:px-6 lg:px-8 pt-6">
                {/* 제목 스켈레톤 */}
                <div className="animate-pulse">
                    <div className="h-8 bg-gray-300 rounded-lg w-48 mb-2"></div>
                    <div className="h-4 bg-gray-300 rounded w-96 mb-6"></div>
                </div>
            </div>
            
            <div className="container mx-auto px-3 sm:px-4 lg:px-6 pt-4">
                <div className="bg-white rounded-xl shadow-sm overflow-hidden">
                    <div className="p-4">
                        <div className="space-y-3">
                            {/* 공지사항 아이템 스켈레톤 */}
                            {Array.from({ length: 5 }).map((_, index) => (
                                <div key={index} className="animate-pulse">
                                    <div className="bg-white border border-gray-200 rounded-lg p-3">
                                        <div className="flex items-start justify-between">
                                            <div className="flex-1">
                                                {/* 중요 표시 스켈레톤 */}
                                                <div className="flex items-center gap-2 mb-2">
                                                    <div className="h-5 bg-gray-300 rounded-full w-12"></div>
                                                    <div className="h-5 bg-gray-300 rounded w-3/4"></div>
                                                </div>
                                                
                                                {/* 제목 스켈레톤 */}
                                                <div className="h-4 bg-gray-300 rounded w-full mb-2"></div>
                                                <div className="h-4 bg-gray-300 rounded w-2/3 mb-3"></div>
                                                
                                                {/* 내용 스켈레톤 */}
                                                <div className="h-3 bg-gray-300 rounded w-full mb-1"></div>
                                                <div className="h-3 bg-gray-300 rounded w-4/5 mb-3"></div>
                                                
                                                {/* 날짜 스켈레톤 */}
                                                <div className="flex items-center gap-4">
                                                    <div className="h-3 bg-gray-300 rounded w-24"></div>
                                                    <div className="h-3 bg-gray-300 rounded w-24"></div>
                                                </div>
                                            </div>
                                            
                                            {/* 화살표 아이콘 스켈레톤 */}
                                            <div className="ml-3 flex-shrink-0">
                                                <div className="h-5 w-5 bg-gray-300 rounded"></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </main>
    );
};

export default NoticeListSkeleton;
